import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';

interface SessionControlsProps {
  startTime: string;
  onReset: () => void;
}

const SessionControls: React.FC<SessionControlsProps> = ({ startTime, onReset }) => (
  <div className="mb-6 space-y-1">
    <p className="text-sm mb-1">Start time: {startTime}</p>
    <button
      onClick={onReset}
      className="px-2 py-1 bg-cyan-600 text-white text-sm rounded hover:bg-cyan-700 transition-colors duration-200"
    >
      <FontAwesomeIcon icon={faRotateRight} className="mr-1"/>
      Reset
    </button>
  </div>
);

export default SessionControls;